/** @flow */

import {
  GetAbsenceReasonsList,
  GetAbsenceReasonsListSuccess,
  GetAbsenceReasonsListError,
  GetAbsenceReasonsActiveList,
  GetAbsenceReasonsActiveListSuccess,
  GetAbsenceReasonsActiveListError,
  GetAbsenceReasonsPendingList,
  GetAbsenceReasonsPendingListSuccess,
  GetAbsenceReasonsPendingListError,
  GetAbsenceReasonsDraftList,
  GetAbsenceReasonsDraftListSuccess,
  GetAbsenceReasonsDraftListError,
  NewAbsenceReason,
  ShowAddAbsenceReasonModal,
  UpdateAbsenceReasonDraft,
  SetAbsenceReasonRevisionSchema,
  GetAbsenceReasonActiveSuccess,
  GetAbsenceReasonActiveError,
  SetAbsenceReasonStatus,
  GetAbsenceReasonSuccess,
  GetAbsenceReasonError,
  ShowAbsenceReasonEditModal,
  SetShowSubmitAbsenceReasonModal,
  SubmitAbsenceReasonForReviewError,
  SetShowCancelAbsenceReasonModal,
  CancelAbsenceReasonReviewError,
  StartAbsenceReasonDraftSuccess,
  SetShowDiscardAbsenceReasonModal,
  SetShowCancelDiscardAbsenceReasonModal,
  DuplicateAbsenceReasonSuccess,
  SetShowDisableAbsenceReasonModal,
  StartAbsenceReasonDraftError,
  DiscardAbsenceReasonDraftError,
  DuplicateAbsenceReasonError,
  CancelAbsenceReasonReviewAndDiscardError,
  DisableAbsenceReasonError,
  ChangeAbsenceReasonsFilterState,
  ChangeAbsenceReasonsFilterType,
  ExportLiveAbsenceReasons,
  ExportLiveAbsenceReasonsSuccess,
  ExportLiveAbsenceReasonsError,
  AddNewAbsenceReason,
  AddNewAbsenceReasonSuccess,
  AddNewAbsenceReasonError,
  GetAbsenceReason,
  UpdateAbsenceReason,
  UpdateAbsenceReasonSuccess,
  UpdateAbsenceReasonError,
} from "@modules/service/constants/actions";
import * as absenceReasonsReducers from "./reducers";
import initialState from "./state";
import type { AbsenceReasonsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AbsenceReasonsState = initialState, action: Object): AbsenceReasonsState => {
  const act = {
    [UpdateAbsenceReason]: absenceReasonsReducers.onUpdateAbsenceReason,
    [UpdateAbsenceReasonSuccess]: absenceReasonsReducers.onUpdateAbsenceReasonSuccess,
    [UpdateAbsenceReasonError]: absenceReasonsReducers.onUpdateAbsenceReasonError,
    [GetAbsenceReason]: absenceReasonsReducers.onGetAbsenceReason,
    [GetAbsenceReasonSuccess]: absenceReasonsReducers.onGetAbsenceReasonSuccess,
    [GetAbsenceReasonError]: absenceReasonsReducers.onGetAbsenceReasonError,
    [AddNewAbsenceReason]: absenceReasonsReducers.onAddNewAbsenceReason,
    [AddNewAbsenceReasonSuccess]: absenceReasonsReducers.onAddNewAbsenceReasonSuccess,
    [AddNewAbsenceReasonError]: absenceReasonsReducers.onAddNewAbsenceReasonError,
    [ExportLiveAbsenceReasons]: absenceReasonsReducers.onExportLiveAbsenceReasons,
    [ExportLiveAbsenceReasonsSuccess]: absenceReasonsReducers.onExportLiveAbsenceReasonsSuccess,
    [ExportLiveAbsenceReasonsError]: absenceReasonsReducers.onExportLiveAbsenceReasonsError,
    [GetAbsenceReasonsList]: absenceReasonsReducers.onGetAbsenceReasonsList,
    [GetAbsenceReasonsListSuccess]: absenceReasonsReducers.onGetAbsenceReasonsListSuccess,
    [GetAbsenceReasonsListError]: absenceReasonsReducers.onGetAbsenceReasonsListError,
    [GetAbsenceReasonsActiveList]: absenceReasonsReducers.onGetAbsenceReasonsActiveList,
    [GetAbsenceReasonsActiveListSuccess]:
      absenceReasonsReducers.onGetAbsenceReasonsActiveListSuccess,
    [GetAbsenceReasonsActiveListError]: absenceReasonsReducers.onGetAbsenceReasonsActiveListError,
    [GetAbsenceReasonsPendingList]: absenceReasonsReducers.onGetAbsenceReasonsPendingList,
    [GetAbsenceReasonsPendingListSuccess]:
      absenceReasonsReducers.onGetAbsenceReasonsPendingListSuccess,
    [GetAbsenceReasonsPendingListError]: absenceReasonsReducers.onGetAbsenceReasonsPendingListError,
    [GetAbsenceReasonsDraftList]: absenceReasonsReducers.onGetAbsenceReasonsDraftList,
    [GetAbsenceReasonsDraftListSuccess]: absenceReasonsReducers.onGetAbsenceReasonsDraftListSuccess,
    [GetAbsenceReasonsDraftListError]: absenceReasonsReducers.onGetAbsenceReasonsDraftListError,
    [NewAbsenceReason]: absenceReasonsReducers.onNewAbsenceReason,
    [ShowAddAbsenceReasonModal]: absenceReasonsReducers.onShowAddAbsenceReasonModal,
    [UpdateAbsenceReasonDraft]: absenceReasonsReducers.onUpdateAbsenceReasonDraft,
    [SetAbsenceReasonRevisionSchema]: absenceReasonsReducers.onSetAbsenceReasonRevisionSchema,
    [GetAbsenceReasonActiveSuccess]: absenceReasonsReducers.onGetAbsenceReasonActiveSuccess,
    [GetAbsenceReasonActiveError]: absenceReasonsReducers.onGetAbsenceReasonActiveError,
    [SetAbsenceReasonStatus]: absenceReasonsReducers.onSetAbsenceReasonStatus,
    [GetAbsenceReasonError]: absenceReasonsReducers.onGetAbsenceReasonError,
    [ShowAbsenceReasonEditModal]: absenceReasonsReducers.onShowAbsenceReasonEditModal,
    [SetShowSubmitAbsenceReasonModal]: absenceReasonsReducers.onSetShowSubmitAbsenceReasonModal,
    [SetShowCancelAbsenceReasonModal]: absenceReasonsReducers.onSetShowCancelAbsenceReasonModal,
    [SubmitAbsenceReasonForReviewError]: absenceReasonsReducers.onSubmitAbsenceReasonForReviewError,
    [CancelAbsenceReasonReviewError]: absenceReasonsReducers.onCancelAbsenceReasonReviewError,
    [StartAbsenceReasonDraftSuccess]: absenceReasonsReducers.onStartAbsenceReasonDraftSuccess,
    [SetShowDiscardAbsenceReasonModal]: absenceReasonsReducers.onSetShowDiscardAbsenceReasonModal,
    [SetShowCancelDiscardAbsenceReasonModal]:
      absenceReasonsReducers.onSetShowCancelDiscardAbsenceReasonModal,
    [DuplicateAbsenceReasonSuccess]: absenceReasonsReducers.onDuplicateAbsenceReasonSuccess,
    [SetShowDisableAbsenceReasonModal]: absenceReasonsReducers.onSetShowDisableAbsenceReasonModal,
    [StartAbsenceReasonDraftError]: absenceReasonsReducers.onStartAbsenceReasonDraftError,
    [DiscardAbsenceReasonDraftError]: absenceReasonsReducers.onDiscardAbsenceReasonDraftError,
    [DuplicateAbsenceReasonError]: absenceReasonsReducers.onDuplicateAbsenceReasonError,
    [CancelAbsenceReasonReviewAndDiscardError]:
      absenceReasonsReducers.onCancelAbsenceReasonReviewAndDiscardError,
    [ChangeAbsenceReasonsFilterState]: absenceReasonsReducers.onChangeAbsenceReasonsFilterState,
    [ChangeAbsenceReasonsFilterType]: absenceReasonsReducers.onChangeAbsenceReasonsFilterType,
    [DisableAbsenceReasonError]: absenceReasonsReducers.onDisableAbsenceReasonError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
